export default __webpack_public_path__ + "static/media/List-documentation.d4f54b28.md";